/**
 * Some constants that can be used inside the moderat advisor.
 */
export class StromcheckConstants {
  // maximum time in days until a local storage element of the advisor should be valid
  static readonly LOCALSTORAGE_TIMEOUT_DAYS = 14;

  // min and max for date validation
  static readonly INVOICE_MIN_DAYS = 180;
  static readonly INVOICE_MAX_DAYS = 458;

  // form inputs
  static readonly FORM_PEOPLE_MAX = 10;
  static readonly FORM_PEOPLE_DEFAULT = 1;
}
